import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './fifth-wheel.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const FifthWheelDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const fifthWheelEntity = useAppSelector(state => state.fifthWheel.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="fifthWheelDetailsHeading">
          <Translate contentKey="fleetSenseApp.fifthWheel.detail.title">FifthWheel</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{fifthWheelEntity.id}</dd>
          <dt>
            <span id="identificationCode">
              <Translate contentKey="fleetSenseApp.fifthWheel.identificationCode">Identification Code</Translate>
            </span>
          </dt>
          <dd>{fifthWheelEntity.identificationCode}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.fifthWheel.truckImplement">Truck Implement</Translate>
          </dt>
          <dd>{fifthWheelEntity.truckImplement ? fifthWheelEntity.truckImplement.licensePlate : ''}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.fifthWheel.company">Company</Translate>
          </dt>
          <dd>{fifthWheelEntity.company ? fifthWheelEntity.company.name : ''}</dd>
        </dl>
        <Button tag={Link} to="/fifth-wheel" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/fifth-wheel/${fifthWheelEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default FifthWheelDetail;
